'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function timeout(promise, ms, error) {
  return new _q2.default.Promise(function (resolve, reject) {
    var timeoutId = setTimeout(function () {
      if (!error || typeof error === 'string') {
        error = new Error(error || 'Timed out after ' + ms + ' ms');
      }
      reject(error);
    }, ms);

    promise.then(function (value) {
      clearTimeout(timeoutId);
      resolve(value);
    }, function (reason) {
      clearTimeout(timeoutId);
      reject(reason);
    });
  });
}

exports.default = timeout;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/q/static-5.30/js/lib/timeout.js
// module id = 140
// module chunks = 2 3